// src/directives/draggable.js
export default {
  mounted (el) {
    el.style.position = 'relative'

    let startX, startY, initialMouseX, initialMouseY

    const mousemove = (e) => {
      try {
        const dx = e.clientX - initialMouseX
        const dy = e.clientY - initialMouseY
        el.style.top = `${startY + dy}px`
        el.style.left = `${startX + dx}px`
      } catch (error) {
        console.log(error)
      }
    }

    const mouseup = () => {
      document.removeEventListener('mousemove', mousemove)
      document.removeEventListener('mouseup', mouseup)
    }

    el.addEventListener('mousedown', (e) => {
      try {
        startX = el.offsetLeft
        startY = el.offsetTop
        initialMouseX = e.clientX
        initialMouseY = e.clientY
        document.addEventListener('mousemove', mousemove)
        document.addEventListener('mouseup', mouseup)
        e.preventDefault()
      } catch (error) {
        console.log(error)
      }
    })
  }
}
